<template>
  <div>
    <!-- <message-list-add-new
      :is-add-new-message-sidebar-active.sync="isAddNewMessageSidebarActive"
      :id="id"
      @refetch-data="refetchData"
    /> -->

    <message-edit-modal
      :message="selectedMessage"
      @success="refetchData"
      @error="showMessage"
    />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <!-- <b-button variant="primary" @click="handleAdd()">
                <span class="text-nowrap">Add Message</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refMessageListTable"
        class="position-relative"
        :items="fetchMessages"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(message_title)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="getMessageImage(data.item.image)"
                icon="alarm"
                variant="primary"
              />
            </template>
            {{ data.item.message_title }}
          </b-media>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
            :class="`action-trigger-btn ${refMessageListTable.localItems.length <= 3 ? 'hor': 'ver'}`"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editMessage(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item :href="'mailto:' + data.item.email">
              <feather-icon icon="MailIcon" />
              <span class="align-middle ml-50">Reply Message</span>
            </b-dropdown-item>

            <b-dropdown-item @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalMessages"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import axiosIns from "@/libs/axios";
import messageStoreModule from "../messageStoreModule";
import useMessagesList from "./useMessagesList";
import MessageEditModal from './MessageEditModal.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
    MessageEditModal
  },
  methods: {
    handleAdd() {
      this.id = 0;
      this.isAddNewMessageSidebarActive = true;
    },
    confirmDelete(id) {
      this.$swal({
        title: "Are you sure?",
        text: "Your action is final and you are not able to recover the data.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store
            .dispatch("bar-message/deleteMessage", id)
            .then((response) => {
              this.refetchData();
              this.showMessage(
                "Success",
                response.data.message,
                "CheckIcon",
                "success"
              );
            })
            .catch((error) => {
              this.showMessage(
                "Fail",
                error.response.data.message,
                "HeartIcon",
                "danger"
              );
            });
        }
      });
    },
    editMessage(message) {
      console.log(message);
      this.selectedMessage = { ...message };
      this.$bvModal.show('modal-edit-message');
    },
  },
  data() {
    return {
      id: 0,
      selectedMessage: {},
    };
  },
  setup() {
    const BAR_MENU_STORE_MODULE_NAME = "bar-message";
    const isAddNewMessageSidebarActive = ref(false);

    if (!store.hasModule(BAR_MENU_STORE_MODULE_NAME))
      store.registerModule(BAR_MENU_STORE_MODULE_NAME, messageStoreModule);

    onUnmounted(() => {
      if (store.hasModule(BAR_MENU_STORE_MODULE_NAME))
        store.unregisterModule(BAR_MENU_STORE_MODULE_NAME);
    });

    const {
      fetchMessages,
      tableColumns,
      perPage,
      currentPage,
      totalMessages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMessageListTable,
      refetchData,
      getMessageImage,
      showMessage,
    } = useMessagesList();

    return {
      //SideBar
      isAddNewMessageSidebarActive,

      fetchMessages,
      tableColumns,
      perPage,
      currentPage,
      totalMessages,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMessageListTable,
      refetchData,
      getMessageImage,
      showMessage,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

